module.exports = "/_next/static/images/Trend02Visual-20e5db94baea5173b3c15bba669f9657.png";